export default __webpack_public_path__ + "static/media/next-step-arrow.044c6d21.svg";